<template>
  <div>
    <title>二级门店管理</title>
    <section class="mainPart">
      <!--S 检索-->
      <el-form :inline="true" :model="searchForm" class="searchForm" @submit.native.prevent>
          <span class="textFl redColor" :title="userInfoMd.flowname" v-if="autologinstore"><b class="blackColor">一级门店：</b>{{userInfoMd&&userInfoMd.flowname?userInfoMd.flowname:''}}</span>
          <el-form-item label="关键词">
              <el-input clearable v-model="searchForm.flowname" placeholder="请输入检索内容"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="querySearch()">查询</el-button>
          </el-form-item>
          <el-form-item v-show="autologinstore">
              <el-button type="primary" plain @click="addOrEditStores(2)">新增</el-button>
          </el-form-item>
          <em class="iconbulb breathTit" v-if="creSecondStorenumm != 0">当前企业的门店创建总余量：<i class="redColor">{{creSecondStorenumm}}</i></em>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <div class="gsListTable individualiz">
        <el-form :model="searchForm" inline size="medium">
          <el-form-item :class="mdactquota ? 'borderline' : 'borderline borderNone'">
            <em class="greyColor">状态</em>
            <el-checkbox-group v-model="searchForm.status" @change="statusChange">
              <el-checkbox label="1">启用</el-checkbox>
              <el-checkbox label="0">禁用</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="borderline borderNone" v-if="mdactquota">
            <em class="greyColor">共享一级门店额度</em>
            <el-checkbox-group v-model="searchForm.issharemdactquota" @change="issharemdactquotaChange">
              <el-checkbox :label="0">不共享</el-checkbox>
              <el-checkbox :label="1">共享</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <el-table class="comTable orderTable" ref="gsTable" :data="secondStoresData" border :maxHeight="tableHeight" v-loading="isLoad">
          <el-table-column label="序号" type="index" fixed></el-table-column>
          <el-table-column label="二级门店名称" min-width="180" fixed>
            <template slot-scope="scope">
              <div class="storeInfo flexUpDownCenter">
                  <a href="javascript:;">
                    <img  v-if="scope.row.mainpiclink" :src="scope.row.mainpiclink" alt="">
                    <img v-else src="https://presale.jhtsoft.com/picms/c47499b67d489.png" alt="">
                  </a>
                  <div>
                      <p class="textFl" :title="scope.row.flowname">{{scope.row.flowname?scope.row.flowname:'--'}}</p>
                      <small class="textHiden greyColor" v-if="scope.row.deliverymicrostorename" :title="scope.row.deliverymicrostorename">发货微门店：{{scope.row.deliverymicrostorename}}</small>
                  </div>
              </div> 
            </template>
          </el-table-column> 
          <el-table-column label="剩余激活额度（￥）" prop="disquota" v-if="mdactquota" min-width="200">
            <template slot-scope="scope">
              <p class="priceFont greenColor"> {{ (scope.row.issharemdactquota == 1 ? scope.row.pdisquota : scope.row.disquota) | formatAmount }}</p>
              <el-tag v-if="scope.row.issharemdactquota == 1" type="danger" plain>共享一级门店额度</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="已激活扣除额度（￥）" prop="usedisquota" v-if="mdactquota" min-width="200">
            <template slot-scope="scope">
              <span class="blueColor priceFont">
                {{ (scope.row.usedquota ? scope.row.usedquota : scope.row.usedisquota) | formatAmount}}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="联系人" min-width="200">
            <template slot-scope="scope">
              <div class="linkWrap">
                <p class="textFl iconuser" :title="scope.row.linkman">{{scope.row.linkman || '--'}}</p>
                <p class="linkNum">
                  <b v-show="scope.row.mobile" class="iconiPhone" :title="scope.row.mobile">{{scope.row.mobile}}</b>
                  <b v-show="scope.row.tel" class="icongh" :title="scope.row.tel">{{scope.row.tel}}</b>
                </p>
                <span v-if="!scope.row.mobile && !scope.row.tel">--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="已关联微门店" min-width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.bindstorenumber && scope.row.bindstorenumber>0" class="iconhand cityName" @click="bindMicroStore(4,scope.row)"><b>{{ scope.row.bindstorenumber }}</b></span>
              <span v-else class="nohandNum">{{ scope.row.bindstorenumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="详细地址" min-width="200">
            <template slot-scope="scope">
              <p class="textFl pdr70">{{scope.row.province}}{{scope.row.city}}{{scope.row.district}}</p>
              <small class="textFl greyColor pdr70" :title="scope.row.addrdet">{{scope.row.addrdet || '--'}}</small>
            </template>
          </el-table-column>
          <el-table-column label="状态" min-width="100">
            <template slot-scope="scope">
              <el-switch :value="scope.row.status? true : false" @change="handleStatus(scope.row.flowcode,scope.row.status)" :width="45" class="isSwitch" :active-text="scope.row.status?'启':'禁'"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140" fixed="right">
            <template slot-scope="scope">
                <!-- <p class="handle">
                  <span title="详情" @click="addOrEditStores(0,scope.row.flowcode)"><i class="icondetails"></i></span>
                  <span title="编辑" @click="addOrEditStores(1,scope.row.flowcode)"><i class="iconedit"></i></span>
                  <span v-if="scope.row.status" title="绑定微门店" @click="bindMicroStore(3,scope.row)"><i class="iconbindstore"></i></span>
                </p> -->
                <el-dropdown trigger="click" @command="handleCommand" placement="bottom">
                  <span class="el-dropdown-link" > 
                      全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{type:'detail',row:scope.row}">详情</el-dropdown-item>
                      <el-dropdown-item :command="{type:'edit',row:scope.row}">编辑</el-dropdown-item>
                      <el-dropdown-item v-if="ElementControls('mdactquota') == 1 && !scope.row.issharemdactquota" :command="{type:'changeActiveAmount',row:scope.row}" >激活额度变更</el-dropdown-item>
                      <el-dropdown-item v-if="ElementControls('mdactquota') == 1" :command="{type:'getChangeActiveRecord',row:scope.row}">激活额度变更记录</el-dropdown-item>
                      <el-dropdown-item v-if="scope.row.status" :command="{type:'bindMicroStore',row:scope.row}">绑定微门店</el-dropdown-item>
                  </el-dropdown-menu>    
                </el-dropdown>
            </template>
          </el-table-column>
          <template slot="empty" v-if="isLoad">
              <div :class="{noData:isLoad}"></div>
          </template>
          <template slot="empty" v-else>
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
      </div>
      <!-- E 列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pagebean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->
    </section>

    <!-- S 增改查二级门店 -->
    <div v-if="createSecStoreShow">
      <CreateSecondaryStore :createSecStoreShow="createSecStoreShow" :operateType="operate" :currentFlowcode="currentFlowcode" @closeSecStoreDlg="closeSecStoreDlg"></CreateSecondaryStore>
    </div>
    <!-- E 增改查二级门店 -->

    <!-- S 绑定微门店 -->
    <StoreChose :chosestoreDatas="storeList" :objectType="4" :storeChoseDialogVisible="storeChoseDialogVisible" @closeChild="getCloseStoreCldd" @chosestoreData="chosestoreData"></StoreChose>
    <!-- E 绑定微门店 -->

    <!-- S 查看微门店 -->
    <StoreCheck :storeList="storeList" :currentFlowname="currentFlowname" :objectType="4" :storeCheckDialogVisible="storeCheckDialogVisible" @closeChild="getCheckStoreCld"></StoreCheck>
    <!-- E 查看微门店 -->

    <!-- S 激活额度变更弹窗 -->
    <el-dialog class="comDlog auditAllBox" :visible.sync="changeAmountShow" title="激活额度变更" append-to-body :close-on-click-modal="false">
      <el-form :model="balanceForm" label-width="200px" class="commonForm">
        <el-form-item label="可分配激活额度" class="noMarginBot">
          <p class="priceFont redColor"> <i>￥</i>{{ userInfoMd.disquota | formatAmount }}</p>
        </el-form-item>
        <el-form-item label="变更对象" class="allWidth noMarginBot">
          {{currentRowinfo.flowname}}
        </el-form-item>
        <el-form-item label="剩余激活额度" class="noMarginBot">
          <p class="priceFont orangeColor"> <i>￥</i>{{ currentRowinfo.disquota | formatAmount }}</p>
        </el-form-item>
        <el-form-item  label="类型">
            <el-radio-group v-model="balanceForm.type">
              <el-radio :label="0">增加</el-radio>
              <el-radio :label="1">扣减</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="激活额度">
            <el-input v-model="balanceForm.disquota" @input="getLimitMoney(balanceForm.disquota)" maxlength="9" clearable>
              <template slot="prepend">￥</template>
            </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="getSubmitRed(1)">确定</el-button>
          <el-button @click="getSubmitRed(0)">取消</el-button>
      </span>
    </el-dialog>
    <!-- E 激活额度变更弹窗 -->

     <!-- S 激活额度变更弹窗 -->
    <el-dialog class="comDlog wideDlog" :visible.sync="changeAmountRecordShow" title="激活额度变更记录" append-to-body :close-on-click-modal="false">
      <ActivateRecord v-if="changeAmountRecordShow" :isFirstLev="0" :rowInfo="currentRowinfo"></ActivateRecord>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeAmountRecordShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- E 激活额度变更弹窗 -->
    
  </div>
</template>
<script>
import { bus } from '@/util/bus';
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name: 'SecondaryStores',
  data () {
    return {
      isLoad:false,//加载中
      searchForm: {
        flowname: "", //关键词
        status: [],//状态
        issharemdactquota:[],//激活额度分配类型 0：独立激活额度  1：共享一级门店额度
      },
      secondStoresData:[
      ],//列表信息
      tableHeight: window.innerHeight*.8, //表格动态高度
      operate:2,//0:详情 1:编辑，2:新增，3:绑定微门店，4：查看已绑微门店
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebean: {
          totalnum: 0,
      }, // 获取到的列表分页信息
      createSecStoreShow:false,//增改查弹窗
      creSecondStorenumm:0,//二级门店上限
      currentFlowcode:'',//当前流向编号
      currentFlowname:'',//当前流向名称

      storeList:[],//已选微门店对象
      flowcodes:'',//已绑定微门店编号
      storeCheckDialogVisible:false,
      storeChoseDialogVisible:false,
      storeopertype:'',//总部跳转门店操作类型: add:新增 edit:编辑 detail:详情 statuschange:状态启禁
      userInfoMd:{},//当前登录一级门店
      autologinstore:'',//缓存自动登录门店

      mdactquota: 0,//门店激活额度是否开启
      currentRowinfo:{},//当前操作门店信息
      balanceForm: {
        type:0,
        disquota:''
      },
      changeAmountShow:false,//激活额度变更弹窗
      changeAmountRecordShow:false,//激活额度变更记录弹窗
    }
  },
  watch:{
    'balanceForm.type':function(val){
      this.getLimitMoney(this.balanceForm.disquota)
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
    CreateSecondaryStore: resolve => require(["@/components/ManageFolder/SecondaryStore/CreateSecondaryStore.vue"],resolve),
    StoreChose: resolve =>require(["@/components/CardsFolder/StoreChose.vue"], resolve), //选择微门店
    StoreCheck: resolve =>require(["@/components/CardsFolder/StoreCheck.vue"], resolve), //查看微门店
    ActivateRecord: resolve => require(['./ActivateRecord.vue'],resolve),//激活额度变更记录
  },
  methods: {
    //---------------------------------------------------------门店激活额度变更 zly  2025-06-18  start------------------------
    // 激活额度切换
    issharemdactquotaChange(){
      if(this.searchForm.issharemdactquota.length > 1) {
          this.searchForm.issharemdactquota.splice(0,1)
      }
      this.currentPage = 1;
      this.getFlowList();
    },
    //操作指令
    handleCommand(command) {
      this.storeopertype = command.type;
      let row = command.row;
      if(command.type == 'detail'){ //详情
        this.addOrEditStores(0,row.flowcode);
      }else if(command.type == 'edit'){ //编辑
        this.addOrEditStores(1,row.flowcode);
      }else if(command.type == 'changeActiveAmount'){ //激活额度变更
        this.getChangeAmount(0,row);
      }else if(command.type == 'getChangeActiveRecord'){ //激活额度变更记录
        this.getChangeActiveRecord(0,row);
      }else if(command.type == 'bindMicroStore'){ //绑定微门店
        this.bindMicroStore(3,row);
      }
    },
    //获取流向详情最新的金额信息
    viewDistributorAll(type,flowcode) {
      api.GET_FLOWDETAIL({ flowcode: flowcode }).then(res => {
        if (res.data.status == "200") {  
          if(type==1){
            this.currentRowinfo = res.data.data;
            if(this.storeopertype == 'changeActiveAmount'){
              this.changeAmountShow = true;
            }else if(this.storeopertype == 'getChangeActiveRecord'){
              this.changeAmountRecordShow = true;
            }
          }else{
            let userInfoMd = res.data.data;
            this.userInfoMd.disquota = userInfoMd.disquota;
            this.userInfoMd.usedisquota = userInfoMd.usedisquota;
            localStorage.setItem('userInfoMd', JSON.stringify(this.userInfoMd));
            bus.$emit('getNewUserinfo');
          }
        } else {
          console.log("获取详情信息失败！");
        }
      });
    },
    // 金额验证
    getLimitMoney(val){
      this.balanceForm.disquota = this.amountChech(val);
      if (this.balanceForm.type == 0) {
        if(this.balanceForm.disquota > this.userInfoMd.disquota){
          this.balanceForm.disquota = this.userInfoMd.disquota;
        }
      }else{
        if(this.balanceForm.disquota > this.currentRowinfo.disquota){
          this.balanceForm.disquota = this.currentRowinfo.disquota;
        }
      }
    },
    // 打开激活额度变更弹窗
    getChangeAmount(type,row){
      this.viewDistributorAll(0,this.userInfoMd.flowcode);//获取最新一级门店信息
      this.balanceForm = {
        type:0,
        disquota:''
      }
      if(type == 1){
        this.viewDistributorAll(type,row);
      }else{
        this.currentRowinfo = row;
        this.changeAmountShow = true;
      }
    },
    //查看激活额度变更记录
    getChangeActiveRecord(type,row){
      if(type == 1){
        this.viewDistributorAll(type,row);
      }else{
        this.currentRowinfo = row;
        this.changeAmountRecordShow = true;
      }
    },
    // 提交激活额度变更
    getSubmitRed(val){
      if(val==1){
        if(this.balanceForm.disquota == '' || parseFloat(this.balanceForm.disquota) == 0){
          this.$message.error('请输入大于0的金额！');
          return false;
        }
        if(this.balanceForm.type == 1){
          if(this.balanceForm.disquota > (this.currentRowinfo.disquota )){
            this.$message.error(`扣减金额不能大于总额度！`);
            return false;
          }
        }
        let params = {
          type:this.balanceForm.type,
          disquota:Number(this.balanceForm.disquota),
          flowcode:this.currentRowinfo.flowcode
        }
        api.UPDISQUOTA(params).then((res) => {
          if(res.data.status == '200'){
            this.$message.success(res.data.message);
            this.getFlowList();
            this.changeAmountShow = false;
            this.viewDistributorAll(0,this.userInfoMd.flowcode);//获取最新一级门店信息
          }else{
            this.$message.error(res.data.message);
          }
        })
      }else{
        this.changeAmountShow = false;
      }
      
    },
    //---------------------------------------------------------门店激活额度变更 zly  2025-06-18  end------------------------
    //获取门店创建余量
    getRestStoreNum(val){
      api.GETSTORENUMBER().then(res =>{
        if(res.data.status == '200'){
          this.creSecondStorenumm = res.data.data;
          if(val==0 && this.$route.query && this.$route.query.storeopertype == 'add'){ 
            this.addOrEditStores(2);
          }
        }else{
          this.creSecondStorenumm = 0;
        }
      }).catch()
    },
    // 状态检索切换
    statusChange(){
      if(this.searchForm.status.length > 1) {
        this.searchForm.status.splice(0,1);
      }
      this.querySearch();
    },
    //检索
    querySearch(){
      // if(this.ElementControls('mdactquota')==1){
      //   this.viewDistributorAll(0,this.userInfoMd.flowcode);//获取最新一级门店信息
      // }
      this.currentPage = 1;
      this.getFlowList();
      this.getRestStoreNum(1);//获取门店创建余量
    },
    // 获取列表
    getFlowList(){
      let params = {
        flowname:this.searchForm.flowname,
        objtype:'9',  //0:门店；1：发货网点；2：一级分销；4：微门店；5.企业微门店； 9:门店二级门店；
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      }
      if(this.searchForm.status[0]){
        params.status =  Number(this.searchForm.status[0]);
      }
      //一级可用额度
      if(this.mdactquota){
        params.issharemdactquota = Number(this.searchForm.issharemdactquota[0]);//激活额度分配类型 0：独立激活额度  1：共享一级门店额度
      }
      this.isLoad = true;
      api.GET_FLOWLIST(params).then((res) => {
        this.isLoad = false;
        if(res.data.status == '200'){
          if(res.data.data && res.data.data != 'null'){
            this.secondStoresData = res.data.data;
          }
          if(res.data.pagebean){
            this.pagebean = res.data.pagebean;
          }
        }
      }).catch(err => {
        this.isLoad = false;
      })
    },
    // 接收分页信息
    updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getFlowList();
    },
    //快捷切换状态
    handleStatus(flowcode,val){
      let valTxt = '';
      let status = 0;
      if(!val){
          valTxt = '启用';
          status = 1;
      }else{
          valTxt = '禁用';
          status = 0;
      }
      MessageBox.confirm(`确定${valTxt}当前二级门店吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
            ucodes:flowcode,
            status:status
        }
        api.UPDATEFLOWSTATUS(params).then((res) => {
            if(res.data.status == '200'){
                this.$message.success(`${valTxt}成功`);
                this.getFlowList()
            }else{
                this.$message.error(res.data.message)
            }
        })
      }).catch(() => {});
    },
    // 增改查弹框
    addOrEditStores(operate,flowcode){
      if(operate == 2){
        if(this.creSecondStorenumm <=0){
          MessageBox.alert(`二级门店创建数量已达上限，无法继续创建！`, '提示', {
            confirmButtonText: '关闭',
            type: 'warning'
          }).then(() => {}).catch(() => {});
          return false;
        }
      }
      this.operate = operate;
      this.currentFlowcode = flowcode;
      this.createSecStoreShow = true;
    },
    //关闭增改查
    closeSecStoreDlg(val){
      this.createSecStoreShow = false;
      if(val == 1){
        this.currentPage = 1;
        setTimeout(() => {
          this.getFlowList();
        }, 300);
        if(this.operate == 2){
          this.getRestStoreNum(1);//更新门店创建余量
        }
      }
    },
    //查看、绑定已绑定微门店
    bindMicroStore(type,row){
      this.operate = type;
      this.currentFlowcode = row.flowcode;
      if(type == 3){ //绑定微门店
        this.haveLinkedStores(row.flowcode);
      }else if(type == 4){ //查看微门店
        this.currentFlowname = row.flowname;
        this.haveLinkedStores(row.flowcode);
      }
    },
    //获取当前门店已关联的微门店列表
    haveLinkedStores(flowcode){
      let params = {
        type:0,
        flowcode:flowcode
      };
      this.isLoad = true;
      api.GETBINDWXFLOW(params).then(res => {
        this.isLoad = false;
        if(res.data.status == '200'){
          if(res.data.data && res.data.data != 'null'){
            this.storeList = res.data.data;
            if(this.operate == 4){
              this.storeCheckDialogVisible = true;
            }else if(this.operate == 3){
              this.storeChoseDialogVisible = true;
            }
          }
        }else{
          this.$message.error(res.data.message)
        }
      }).catch(err =>{
        this.isLoad = false;
      })
    },
    // 关闭查看门店弹窗
    getCheckStoreCld() {
      this.storeCheckDialogVisible = false;
    },
    //已绑定微门店数据
    chosestoreData(type){
      this.storeList = type;
      let parm ='';
      if(type.length>0){
        type.map((item,index)=>{
          if(index!=0){
            parm += ',';
          }
          parm += item.flowcode;
        })
      }
      this.flowcodes = parm;
      this.bindSmallStore(this.flowcodes);
      console.log(this.flowcodes,'已选的编号列表')
    },
    //二级门店绑定微门店
    bindSmallStore(flowcodes){
      let params = {
        flowcode:this.currentFlowcode,
        flowcodes:flowcodes == 'null'?'':flowcodes,
      }
      api.SECFLOWBINDWXFLOW(params).then(res => {
        if(res.data.status == '200'){
          this.$message.success(res.data.message);
          this.getFlowList();
        }else{
          this.$message.error(res.data.message);
        }
      }).catch()
    },
    // 关闭选择门店弹窗
    getCloseStoreCldd() {
      this.storeChoseDialogVisible = false;
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    if(localStorage.getItem('userInfoMd')){
      this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'))
    }
    if(sessionStorage.getItem('autologinstore')){
      this.autologinstore = JSON.parse(sessionStorage.getItem('autologinstore'))
    }
    this.mdactquota = Number(this.ElementControls('mdactquota'));//是否开通门店激活额度
    
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },250);
    this.getFlowList();//获取列表
    this.getRestStoreNum(0);//获取门店创建余量
    setTimeout(() => {
      if(this.$route.query && this.$route.query.storeopertype && this.$route.query.flowcode){ 
        let flowcode = this.$route.query.flowcode;
        this.storeopertype = this.$route.query.storeopertype;
        if(this.storeopertype != 'add'){
          if(this.storeopertype == 'edit'){
            this.addOrEditStores(1,flowcode);
          }else if(this.storeopertype == 'detail'){
            this.addOrEditStores(0,flowcode);
          }else if(this.storeopertype == 'statuschange'){
            let status = Number(this.$route.query.status);
            this.handleStatus(flowcode,status)
          }else if(this.storeopertype == 'changeActiveAmount'){ //变更激活额度
            this.getChangeAmount(1,flowcode);
          }else if(this.storeopertype == 'getChangeActiveRecord'){ //查看激活额度变更记录
            this.getChangeActiveRecord(1,flowcode);
          }
        } 
      }
    }, 100);

    
    
  },
  destroyed(){
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.searchForm .textFl {display: inline-block; max-width: 250px; width: auto; line-height: 40px; padding-right:20px; vertical-align: top;}
.storeInfo a{
    width: 60px;
    height: 60px;
    position: relative;
    border:solid 1px #ebeeeb;
    box-sizing: border-box;
    margin-right: 10px;
}
.storeInfo a img{
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}
.storeInfo div{
    flex:0 0 calc(100% - 70px);
    max-width: calc(100% - 70px);
    text-align:left;
}


.breathTit{
  line-height: 40px;
  font-size: 13px;
}
.breathTit i{margin: 0 5px;font-weight: bold;}


/* 激活额度变更 */
.auditAllBox >>> .el-dialog {width:750px;height:400px;}
.auditAllBox .dgTip {padding-left:30px; font-size: 14px; color:#333; }
.auditAllBox >>> .noMarginBot {margin-bottom:0;}
/*激活额度变更记录*/
.wideDlog >>> .el-dialog { width: 80%; min-width:1400px; height: 90%; min-height:680px;}
.wideDlog >>> .el-dialog__body {max-height:calc(100% - 70px);}
</style>




// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/SecondaryStores.vue